import React from "react";
import { Clock, Mail } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../lib/auth";

export default function PendingApproval({ user }) {
  const { logout } = useAuth();
  const rejected = user.status === "rejected";
  return (
    <div className="mx-auto max-w-2xl px-6 py-20" data-testid="pending-approval">
      <div className="rounded-lg border border-[#E2E8F0] bg-white p-10 shadow-sm">
        <div className={`grid h-12 w-12 place-items-center rounded-md ${rejected ? "bg-[#9E4747]/10 text-[#9E4747]" : "bg-[#C99B4B]/15 text-[#8A6A2E]"}`}>
          <Clock size={20} />
        </div>
        <h1 className="mt-4 font-heading text-2xl font-semibold text-[#1A2024]">
          {rejected ? "Account not approved" : "Your authority account is pending review"}
        </h1>
        <p className="mt-3 font-body text-sm text-[#5C6873]">
          {rejected
            ? "An administrator has reviewed your request and was not able to approve your authority account. If you believe this is an error, please contact the EuroFind administrators with additional credentials."
            : (
                <>
                  Thank you for registering as <strong>{user.name}</strong> for <strong>{user.organization || "your organisation"}</strong>.
                  An administrator will check your professional credentials before giving you access to add cases and
                  see matches. This usually takes about one business day.
                </>
              )}
        </p>
        <div className="mt-6 flex items-center gap-2 rounded-md border border-[#E2E8F0] bg-[#F8F9FA] p-4 font-body text-sm text-[#1A2024]">
          <Mail size={16} className="text-[#6B7F82]" /> {user.email}
        </div>
        <div className="mt-6 flex justify-end">
          <Button variant="outline" className="border-[#E2E8F0] text-[#2E3A46]" onClick={logout} data-testid="pending-logout-btn">
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
